import React from 'react';
import { Trophy } from 'lucide-react';
import type { Achievement } from '../lib/achievements';

interface AchievementPointsProps {
  achievements: Achievement[];
}

const AchievementPoints: React.FC<AchievementPointsProps> = ({ achievements }) => {
  const totalPoints = achievements.reduce((total, achievement) => {
    return total + (achievement.unlocked ? achievement.points : 0);
  }, 0);

  const maxPoints = achievements.reduce((total, achievement) => {
    return total + achievement.points;
  }, 0);

  const difficultyColors = {
    easy: 'bg-green-100 text-green-700',
    medium: 'bg-blue-100 text-blue-700',
    hard: 'bg-purple-100 text-purple-700',
    epic: 'bg-orange-100 text-orange-700',
    legendary: 'bg-red-100 text-red-700'
  };

  return (
    <div className="bg-white rounded-xl shadow-lg p-6 mb-8">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <Trophy className="h-6 w-6 text-yellow-500" />
          <h3 className="text-xl font-bold text-gray-900">Achievement Punkte</h3>
        </div>
        <div className="text-2xl font-bold text-yellow-500">
          {totalPoints} / {maxPoints}
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {(['easy', 'medium', 'hard', 'epic', 'legendary'] as const).map(difficulty => {
          const difficultyAchievements = achievements.filter(a => a.difficulty === difficulty);
          const earnedPoints = difficultyAchievements.reduce((total, achievement) => {
            return total + (achievement.unlocked ? achievement.points : 0);
          }, 0);
          const possiblePoints = difficultyAchievements.reduce((total, achievement) => {
            return total + achievement.points;
          }, 0);

          return (
            <div 
              key={difficulty}
              className={`${difficultyColors[difficulty]} rounded-lg p-4 text-center`}
            >
              <div className="font-medium capitalize mb-1">{difficulty}</div>
              <div className="text-sm">
                {earnedPoints} / {possiblePoints}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AchievementPoints;